import {
    GET_ALL_DATA,
    ADD_DATA,
    ADD_VENDOR,
    DELETE_VENDOR,
    CHECK_RFI_CODE,
    SUBMIT_RFI_VENDOR
  } from "@/api/ideation/rfi";
  import querystring from "query-string";
  
  const state = {
    list: [],
  };
  
  const mutations = {
    SET_LIST: (state, payload) => {
      state.list = payload;
    },
  };
  
  const actions = {
    GET_LIST: async ({ commit }, params) => {
      params = querystring.stringify(params);
      const resp = await GET_ALL_DATA(params);
      const data = resp.data.data.data;
      commit("SET_LIST", data);
    },
    CREATE_DATA: async ({ commit }, args) => {
      return await ADD_DATA(args);
    },
    CREATE_VENDOR: async ({ commit }, args) => {
      return await ADD_VENDOR(args);
    },
    DELETE_VENDOR: async ({ commit }, args) => {
      return await DELETE_VENDOR(args);
    },
    CHECK_RFI_CODE: async ({ commit }, args) => {
      const resp = await CHECK_RFI_CODE(args);
      return resp.data.data;
    },
    SUBMIT_RFI_VENDOR: async ({ commit }, args) => {
      return await SUBMIT_RFI_VENDOR(args);
    },
  };
  
  const getters = {
    list: (state) => state.list,
  };
  
  export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
  };
  